import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function RedirectToPrevious() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const lastRoute = localStorage.getItem("lastRoute") || "/";

    if (location.pathname !== lastRoute) {
      navigate(lastRoute, { replace: true });
    }
  }, [location, navigate]);
  return null;
}
